import { OverlaySpinner } from '@ankr.com/ui';
import loadable from '@loadable/component';

import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { NonEnterpriseGuard } from 'modules/accountStatus/components/EnterpriseGuard';
import { homeRoutesConfig } from 'domains/home/routes';

const PricingPage = loadable(
  async () => {
    const module = await import('./PricingPage');

    return module.PricingPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

const homePath = homeRoutesConfig.home.generatePath();

export const PricingPageContainer = () => {
  return (
    <NoSSRGuard>
      <NonEnterpriseGuard fallback={homePath}>
        <PricingPage />
      </NonEnterpriseGuard>
    </NoSSRGuard>
  );
};
